export const OTHER_OPTION_TEXT = 'Other';

export function isOtherOptionText(text) {
    if (text === null || text === undefined) {
        return false;
    }
    return String(text).trim().toLowerCase() === OTHER_OPTION_TEXT.toLowerCase();
}

export function isOtherOption(option) {
    return option && isOtherOptionText(option.option_text);
}

export function questionHasOtherOption(question) {
    if (!question || !Array.isArray(question.options)) {
        return false;
    }
    for (let i = 0; i < question.options.length; i++) {
        if (isOtherOption(question.options[i])) {
            return true;
        }
    }
    return false;
}

export function getOtherOption(question) {
    if (!question || !Array.isArray(question.options)) {
        return null;
    }
    for (let i = 0; i < question.options.length; i++) {
        if (isOtherOption(question.options[i])) {
            return question.options[i];
        }
    }
    return null;
}

export function isOtherOptionSelected(question, answer) {
    if (!question || !answer) {
        return false;
    }
    const otherOption = getOtherOption(question);
    if (!otherOption || otherOption.id === null || otherOption.id === undefined) {
        return false;
    }
    const otherId = parseInt(otherOption.id, 10);
    if (question.type === 'checkbox') {
        const ids = answer.option_ids || [];
        for (let i = 0; i < ids.length; i++) {
            if (parseInt(ids[i], 10) === otherId) {
                return true;
            }
        }
        return false;
    }
    if (question.type === 'radio' || question.type === 'select') {
        if (answer.option_id === null || answer.option_id === undefined) {
            return false;
        }
        return parseInt(answer.option_id, 10) === otherId;
    }
    return false;
}

export function isOtherCommentEnabled(question) {
    if (!question) {
        return false;
    }
    if (!questionHasOtherOption(question)) {
        return false;
    }
    return question.other_option_comment_enabled !== false;
}

export function shouldShowOtherCommentField(question, answer) {
    return isOtherOptionSelected(question, answer) && isOtherCommentEnabled(question);
}

export function normalizeQuestionOtherFields(question) {
    if (!question || !['radio', 'checkbox', 'select'].includes(question.type)) {
        question.add_other_option = false;
        question.other_option_comment_enabled = false;
        return question;
    }

    const hasOther = questionHasOtherOption(question);
    if (hasOther) {
        question.add_other_option = true;
    } else if (question.add_other_option === undefined || question.add_other_option === null) {
        question.add_other_option = false;
    } else {
        question.add_other_option = Boolean(question.add_other_option);
    }

    if (question.other_option_comment_enabled === undefined || question.other_option_comment_enabled === null) {
        question.other_option_comment_enabled = hasOther;
    } else {
        question.other_option_comment_enabled = Boolean(question.other_option_comment_enabled);
    }

    return question;
}

export function getOtherCommentTextFromAnswer(answer, question) {
    if (!answer || !question) {
        return '';
    }
    const text = answer.answer_text !== undefined && answer.answer_text !== null
        ? answer.answer_text.toString().trim()
        : '';
    if (!text) {
        return '';
    }
    if (question.type === 'radio' || question.type === 'select') {
        if (answer.option && isOtherOption(answer.option)) {
            return text;
        }
        return '';
    }
    if (question.type === 'checkbox') {
        const answerForCheck = {
            option_ids: answer.option_ids || (answer.options ? answer.options.map(function (opt) { return opt.id; }) : []),
        };
        if (isOtherOptionSelected(question, answerForCheck)) {
            return text;
        }
    }
    return '';
}

export function formatSingleChoiceAnswerForDisplay(answer, question) {
    const optionText = answer && answer.option && answer.option.option_text
        ? answer.option.option_text
        : '';
    const comment = getOtherCommentTextFromAnswer(answer, question);
    if (optionText && comment) {
        return optionText + ': ' + comment;
    }
    return optionText || comment || '';
}

export function formatMultipleChoiceAnswerForDisplay(answer, question) {
    let result = '';
    if (answer && answer.options && answer.options.length > 0) {
        result = answer.options.map(function (o) { return o.option_text; }).join(', ');
    }
    const comment = getOtherCommentTextFromAnswer(answer, question);
    if (comment) {
        if (result) {
            result = result + ' — ' + comment;
        } else {
            result = 'Other: ' + comment;
        }
    }
    return result;
}
